import { useContext } from 'react'
import { useQuery, QueryKey } from 'react-query'

import { useAuth } from '@auth/auth.hooks'
import { getUserPermissions } from '@permissions/permissions.services'
import { PermissionsContext } from '@permissions/permissions.context'

export const usePermissions = () => {
  const { currentUser, userToken } = useAuth()

  const email = currentUser?.email

  const queryKey: QueryKey = ['userPermission', { email }]
  const queryOptions = {
    staleTime: 60 * 60 * 1000,
    enabled: !!userToken,
  }
  const queryFunc = async () => {
    const { data } = await getUserPermissions()

    return data.scopes
  }

  const { data: permissions, ...rest } = useQuery(queryKey, queryFunc, queryOptions)

  return { permissions: permissions ?? [], queryKey, ...rest }
}

export const usePermissionContext = () => {
  return useContext(PermissionsContext)
}
